var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VerticalView } from './vertical-view';
/**
 * week view
 */
var Week = /** @class */ (function (_super) {
    __extends(Week, _super);
    /**
     * Constructor for week view
     *
     * @param {Schedule} parent Accepts the schedule instance
     */
    function Week(parent) {
        var _this = _super.call(this, parent) || this;
        _this.viewClass = 'e-week-view';
        return _this;
    }
    Week.prototype.startDate = function () {
        return this.getViewStartDate();
    };
    Week.prototype.endDate = function () {
        return this.getViewEndDate();
    };
    /**
     * Get module name.
     *
     * @returns {string} Returns the module name.
     */
    Week.prototype.getModuleName = function () {
        return 'week';
    };
    return Week;
}(VerticalView));
export { Week };
